import React, { useEffect } from "react";
import { Form, Input, Button } from "antd";
import Modal from "components/Modal/Modal";
import { FormDatePicker } from "components/FormItems/FlatFormItems";
import moment from "moment";

export default function ChangeSendDateModal({ visible, onClose, onSubmit }) {
  const [form] = Form.useForm();

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onSubmit(values.sendDate.format());
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [visible]);

  return (
    <Modal
      title="Change Send Date"
      visible={visible}
      onCancel={onClose}
      onOk={handleOk}
      footer={[
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          Submit
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" name="change_email_form">
        <FormDatePicker
          form={form}
          name="sendDate"
          label="Select Date"
          variant="underlined"
          formItemStyles={{ marginBottom: 0 }}
          disabledDate={(current) =>
            current.isBefore(moment().subtract(1, "day"))
          }
        //   onChange={(value, date) => {
        //     setScheduledDate(value);
        //   }}
          required
        />
      </Form>
    </Modal>
  );
}
